import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';

const Index = (props) => {
    axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

    // ユーザー区分
    const is_general_user = props.current_m_user_user_kbn === "reader" ? true : false 
    // テンプレート
    const [partGroups, setPartGroups] = useState([]);

    // 削除対象テンプレート
    const [deletePartGroup, setDeletePartGroup] = useState({id: 0, name: ""});

    // 削除モーダルメッセージ
    const [isLinked, setIsLinked] = useState(false);

    const [searchName, setSearchName] = useState("");
    // メッセージエリア
    const [infoMessage, setInfoMessage] = useState("");
    
    // 初期ロード
    useEffect(() =>{
        axios.get(
        '/api/internal/part_groups/get_part_groups', { params: { name: searchName }}
        ).then(function (response) {
            setPartGroups(response.data.m_part_groups);
        })
        .catch(error => {
            alert(error.response.data.message)
        }
        ); 
    }, [])

    function searchPartGroup(){
        axios.get(
            '/api/internal/part_groups/get_part_groups', { params: { name: searchName }}
        ).then(function (response) {
            setPartGroups(response.data.m_part_groups);
            }
        ).catch(error => {
            alert(error.response.data.message)
        }
        ); 
    }

    function onClickDeleteButton(){
        axios.delete(
            '/api/internal/part_groups/destroy', {
                data: { id: deletePartGroup.id }
            })
            .then(function (response) {
                setPartGroups(
                    partGroups.filter(function(template){
                        return template.id !== deletePartGroup.id
                    })
                ) ;
                setInfoMessage(response.data.message);
            })
            .catch(error => {
                alert(error.response.data.message)
            }
        ); 
    }

    function checkLinked(part_group){
        setIsLinked(false);
        setDeletePartGroup({id: 0, name: ""});
        axios.get(
            '/api/internal/part_groups/linked_templates', { params: { id: part_group.id }}
            ).then(function (response) {
                setDeletePartGroup(part_group);
                response.data.m_templates.length != 0 && setIsLinked(true);
                document.getElementById("open_delete_modal").click();
            })
            .catch(error => {
                alert(error.response.data.message)
            }
            );
    }

    return(
        <>
            { infoMessage &&
                <div className="alert fade in alert-success ">
                    <button type="button" className="close" data-dismiss="alert">×</button>
                    {infoMessage}
                </div>
            }
            <h3>先確認カテゴリ一覧</h3>
            {/* 検索エリア */}
            <div id="part_group_search_area" className="panel panel-success">
                <div className="panel-heading">検索エリア</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="form-group col-md-7 col-xs-12">
                            <label >カテゴリ名</label>
                            <input 
                                type="text" 
                                name="search_name" 
                                id="search_name" 
                                className="form-control col-lg-1" 
                                placeholder="検索したい内容を入力してください"
                                onChange={(e) => setSearchName(e.target.value)}
                            />
                        </div>
                        <div className="form-group col-md-2 col-xs-4 mt10 text-right">
                            <input type="submit" name="button_search" value="検索" className="btn btn-lg btn-primary" data-disable-with="検索" onClick={() => searchPartGroup()} />
                        </div>
                    </div>
                </div> 
            </div>

            <div className="col-md-12 col-xs-12">
                <h3 className="red">管理者以外使用しないでください。<br/>アンケートを表示するには店舗毎にアンケート表示設定をしてください。<br/>※ 新規追加・変更・コピー・削除を行うと、全店舗に反映されます。</h3>
            </div>
            {/* 表示エリア */}
            <div className="table-responsive">
                <table id="notice_table" className="table table-bordered">
                    <thead>
                    <tr className="success">
                        <th scope="col" className="text-center col-md-5 col-sm-5 col-xs-5">カテゴリ名</th>
                        <th scope="col" className="text-center col-md-4 col-sm-4 col-xs-4">説明</th>
                        <th scope="col" className="text-center col-md-2 col-sm-1 col-xs-1">質問数</th>
                        <th scope="col" className="text-center col-md-1 col-sm-1 col-xs-1"></th>
                        <th scope="col" className="text-center col-md-1 col-sm-1 col-xs-1"></th>
                    </tr>
                    </thead>
                    <tbody>
                        { partGroups.map((part_group) =>
                        <>
                            <tr>
                                <td>{part_group.name}</td>
                                <td>{part_group.description}</td>
                                <td>{part_group.part_count}</td>
                                <td className="text-center">
                                    <button disabled={is_general_user} className="btn btn-primary" onClick={ ()=> location.href="/part_groups/edit?id=" + part_group.id}>編集</button>
                                </td>
                                <td className="text-center">
                                    <button disabled={is_general_user} className="btn btn-danger" onClick={() => checkLinked(part_group)}>削除</button>
                                    <input type="hidden" id="open_delete_modal" data-toggle="modal" data-target="#part_group_delete_modal"/>
                                </td>
                            </tr>
                        </>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="actions mt40 text-center va_middle">
                <button disabled={is_general_user} className="btn btn-primary ml5" onClick={ ()=> location.href="/part_groups/new"}>カテゴリ登録</button>
            </div>

            <div className="modal fade" data-backdrop="static" id="part_group_delete_modal">
                <div className="sw-modal-content">
                <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
                    <div className="sw-modal-icon-question sw-modal-icon">?</div>
                    <h2>削除します</h2>
                    <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                    {isLinked && <><div className="red bold">カテゴリ情報に紐づくアンケートが存在します。</div></>}
                    以下のカテゴリ情報を削除します。<br />
                    よろしいですか？<br />
                    【{deletePartGroup && deletePartGroup.name}】<br/>
                    </div>
                    <a type="button"
                        className="sw-modal-btn"
                        style={{ backgroundColor: 'red', textDecoration: 'none'}}
                        data-dismiss="modal"
                        onClick={() => onClickDeleteButton()}
                    >
                    削除する
                    </a>
                    <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
                </div>
                </div>
            </div>
        </>
    )
}
export default Index;